import { IconPropsType } from '..';

export const MefeteIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="80"
    height="20"
    viewBox="0 0 80 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.49561 17.1216L9.49561 2.87826L5.93478 12.3738L2.37395 2.87826L2.37394 17.1216"
      stroke="white"
      strokeWidth="1.18694"
    />
    <path
      d="M20.7716 4.06543H14.8369C14.5091 4.06543 14.2434 4.33114 14.2434 4.6589C14.2434 4.98667 14.5091 5.25237 14.8369 5.25237H20.7716C21.0994 5.25237 21.3651 4.98667 21.3651 4.6589C21.3651 4.33114 21.0994 4.06543 20.7716 4.06543Z"
      fill="url(#paint0_linear_26728_107149)"
    />
    <path
      d="M20.7716 8.81299H14.8369C14.5091 8.81299 14.2434 9.07869 14.2434 9.40646C14.2434 9.73423 14.5091 9.99993 14.8369 9.99993H20.7716C21.0994 9.99993 21.3651 9.73423 21.3651 9.40646C21.3651 9.07869 21.0994 8.81299 20.7716 8.81299Z"
      fill="url(#paint1_linear_26728_107149)"
    />
    <path
      d="M20.7716 13.561H14.8369C14.5091 13.561 14.2434 13.8267 14.2434 14.1545C14.2434 14.4823 14.5091 14.748 14.8369 14.748H20.7716C21.0994 14.748 21.3651 14.4823 21.3651 14.1545C21.3651 13.8267 21.0994 13.561 20.7716 13.561Z"
      fill="url(#paint2_linear_26728_107149)"
    />
    <path
      d="M35.0149 4.06543H26.7063C26.3785 4.06543 26.1128 4.33114 26.1128 4.6589C26.1128 4.98667 26.3785 5.25237 26.7063 5.25237H35.0149C35.3426 5.25237 35.6083 4.98667 35.6083 4.6589C35.6083 4.33114 35.3426 4.06543 35.0149 4.06543Z"
      fill="white"
    />
    <path
      d="M32.641 8.81299H26.7063C26.3785 8.81299 26.1128 9.07869 26.1128 9.40646C26.1128 9.73423 26.3785 9.99993 26.7063 9.99993H32.641C32.9687 9.99993 33.2345 9.73423 33.2345 9.40646C33.2345 9.07869 32.9687 8.81299 32.641 8.81299Z"
      fill="white"
    />
    <path
      d="M32.641 13.561H26.7063C26.3785 13.561 26.1128 13.8267 26.1128 14.1545C26.1128 14.4823 26.3785 14.748 26.7063 14.748H32.641C32.9687 14.748 33.2345 14.4823 33.2345 14.1545C33.2345 13.8267 32.9687 13.561 32.641 13.561Z"
      fill="white"
    />
    <path
      d="M49.2583 4.06543H40.9497C40.6219 4.06543 40.3562 4.33114 40.3562 4.6589C40.3562 4.98667 40.6219 5.25237 40.9497 5.25237H49.2583C49.586 5.25237 49.8518 4.98667 49.8518 4.6589C49.8518 4.33114 49.586 4.06543 49.2583 4.06543Z"
      fill="white"
    />
    <path
      d="M49.2583 8.81299H40.9497C40.6219 8.81299 40.3562 9.07869 40.3562 9.40646C40.3562 9.73423 40.6219 9.99993 40.9497 9.99993H49.2583C49.586 9.99993 49.8518 9.73423 49.8518 9.40646C49.8518 9.07869 49.586 8.81299 49.2583 8.81299Z"
      fill="white"
    />
    <path
      d="M49.2583 13.561H40.9497C40.6219 13.561 40.3562 13.8267 40.3562 14.1545C40.3562 14.4823 40.6219 14.748 40.9497 14.748H49.2583C49.586 14.748 49.8518 14.4823 49.8518 14.1545C49.8518 13.8267 49.586 13.561 49.2583 13.561Z"
      fill="white"
    />
    <path
      d="M65.8755 4.06543H57.5669C57.2391 4.06543 56.9734 4.33114 56.9734 4.6589C56.9734 4.98667 57.2391 5.25237 57.5669 5.25237H65.8755C66.2032 5.25237 66.4689 4.98667 66.4689 4.6589C66.4689 4.33114 66.2032 4.06543 65.8755 4.06543Z"
      fill="white"
    />
    <path
      d="M62.4333 5.25244H61.2463V15.9349H62.4333V5.25244Z"
      fill="white"
    />
    <path
      d="M77.7449 4.06543H69.4362C69.1085 4.06543 68.8428 4.33114 68.8428 4.6589C68.8428 4.98667 69.1085 5.25237 69.4362 5.25237H77.7449C78.0726 5.25237 78.3383 4.98667 78.3383 4.6589C78.3383 4.33114 78.0726 4.06543 77.7449 4.06543Z"
      fill="white"
    />
    <path
      d="M77.7449 8.81299H69.4362C69.1085 8.81299 68.8428 9.07869 68.8428 9.40646C68.8428 9.73423 69.1085 9.99993 69.4362 9.99993H77.7449C78.0726 9.99993 78.3383 9.73423 78.3383 9.40646C78.3383 9.07869 78.0726 8.81299 77.7449 8.81299Z"
      fill="white"
    />
    <path
      d="M77.7449 13.561H69.4362C69.1085 13.561 68.8428 13.8267 68.8428 14.1545C68.8428 14.4823 69.1085 14.748 69.4362 14.748H77.7449C78.0726 14.748 78.3383 14.4823 78.3383 14.1545C78.3383 13.8267 78.0726 13.561 77.7449 13.561Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_26728_107149"
        x1="14.2434"
        y1="4.06543"
        x2="21.3651"
        y2="4.06543"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCC70" />
        <stop
          offset="1"
          stopColor="#FFCC70"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_26728_107149"
        x1="14.2434"
        y1="8.81299"
        x2="21.3651"
        y2="8.81299"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFB3D3" />
        <stop
          offset="1"
          stopColor="#EFB3D3"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_26728_107149"
        x1="14.2434"
        y1="13.561"
        x2="21.3651"
        y2="13.561"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B2C7E7" />
        <stop
          offset="1"
          stopColor="#B2C7E7"
        />
      </linearGradient>
    </defs>
  </svg>
);
